import { useEffect } from 'react';
import fetchIntercept from 'fetch-intercept';
import { useAuth0 } from '@auth0/auth0-react';

const noAuthRoutes = ['/content-provider/collaborators/invitation-info'];

export default function FetchInterceptor() {
	const { getAccessTokenSilently, logout, user } = useAuth0();
	
	
	useEffect(() => {
		
		const request = async (url: string, config: any) => {
			if (noAuthRoutes.some((x) => url.includes(x))) {
				return [url, config];
			}

			const accessToken = await getAccessTokenSilently();
			if (
				!accessToken ||
				!url.startsWith(process.env.REACT_APP_API_BASE_URL || '')
			) {
				return [url, config];
			}

			config.headers.Authorization = `Bearer ${accessToken}`;
			return [url, config];
		};
		
		fetchIntercept.register({
			request,

			requestError: function (error) {
				// Called when an error occured during another 'request' interceptor call
				return Promise.reject(error);
			},

			response: function (response) {
				if (response?.status === 401) {
					logout();
				}
				getAccessTokenSilently({ignoreCache: true}).catch(() => logout());
				return response;
			},

			responseError: function (error) {
				// Handle an fetch error
				return Promise.reject(error);
			},
		});
	}, [getAccessTokenSilently, logout, user]);

	return null;
}
